<template>
  <div>
    <b-container fluid class="content menupage">
      <b-alert
        :show="countdown"
        dismissible
        variant="success"
        @dismissed="countdown = 0"
        @dismiss-count-down="close_alert"
        class="show_alert"
      >
        {{ dismessage }}
      </b-alert>
      <el-tabs
        type="border-card"
        v-model="active_tab"
        @tab-click="changed_tabs"
        :before-leave="check_changed_tabs"
      >
        <el-tab-pane
          v-for="menu in menulist"
          :key="menu.IDn"
          :label="menu.Name1"
          :name="menu.IDn + 'tab'"
          lazy
        >
          <b-card>
            <el-form ref="form">
              <b-row class="mb-0">
                <b-col cols="3">{{ $t('Name') + '1 : ' + cur_menu.Name1 }}</b-col>
                <b-col cols="3">{{ $t('Name') + '2 : ' + cur_menu.Name2 }}</b-col>
                <b-col cols="3">{{ $t('Price Group') + ' ' + cur_menu.PriceGroup }}</b-col>
                <b-col cols="3">{{ $t('Online') + ' ' + ((cur_menu.IsOnline==1)?$t('On'):$t('Off')) }}</b-col>
              </b-row>
              <!-- <b-row class="mb-1">
                <b-col cols="3">
                  <el-form-item size="mini" :label="$t('Start Date')">
                    <el-date-picker
                      v-model="cur_menu.StartDate"
                      @change="change_cur_menu()"
                      type="date"
                      size="mini"
                      class="widthdate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placement="bottom-start"
                      placeholder="Pick a day">
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="small" :label="$t('End Date')">
                    <el-date-picker
                      v-model="cur_menu.EndDate"
                      @change="change_cur_menu()"
                      type="date"
                      size="mini"
                      class="widthdate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placement="bottom-start"
                      placeholder="Pick a day">
                    </el-date-picker>
                  </el-form-item>
                </b-col>
                <b-col cols="6">
                  <el-checkbox-group
                    v-model="cur_menu.LocationID"
                    @change="changed_store()"
                  >
                    <el-checkbox
                      v-for="store in storelist"
                      :key="store.LocationID"
                      :label="store.LocationID"
                      >{{ store.LocationName }}</el-checkbox
                    >
                  </el-checkbox-group>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col cols="3">
                  <el-switch
                    size="mini"
                    v-model="cur_menu.mustHave"
                    :width="30"
                    :active-value="1"
                    :inactive-value="0"
                    @change="change_cur_menu()"
                  ></el-switch>
                  <span class="ml-1">{{ $t("Items Check") }}</span>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="mini" :label="$t('Items Check Start')">
                    <el-select
                      size="mini"
                      class="w-50"
                      v-model="cur_menu.mustHaveStart"
                      placeholder="Start Time"
                      @change="change_cur_menu()"
                    >
                      <el-option v-for="tm in tmlist" :key="tm" :label="tm" :value="tm"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="small" :label="$t('Items Check End')">
                    <el-select
                      size="mini"
                      class="w-50"
                      v-model="cur_menu.mustHaveEnd"
                      placeholder="End Time"
                      @change="change_cur_menu()"
                    >
                      <el-option v-for="tm in tmlist" :key="tm" :label="tm" :value="tm"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="mini" :label="$t('Items Check Remind')">
                    <el-input
                      placeholder="Items Check Remind"
                      v-model="cur_menu.mustHaveWarrning"
                      @change="change_cur_menu()"
                      class="w-50"
                      size="mini"
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row class="mb-1" v-if="cur_menu.IsEMenu==1">
                <b-col cols="3">
                  <el-switch
                    size="mini"
                    v-model="cur_menu.menuTimeControl"
                    :width="30"
                    :active-value="1"
                    :inactive-value="0"
                    @change="change_cur_menu()"
                  ></el-switch>
                  <span class="ml-1">{{ $t("EMenu Time Control") }}</span>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="mini" :label="$t('EMenu Start Time')">
                    <el-select
                      size="mini"
                      class="w-50"
                      v-model="cur_menu.menuStart"
                      placeholder="Start Time"
                      @change="change_cur_menu()"
                    >
                      <el-option v-for="tm in tmlist" :key="tm" :label="tm" :value="tm"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-form-item size="small" :label="$t('EMenu End Time')">
                    <el-select
                      size="mini"
                      class="w-50"
                      v-model="cur_menu.menuEnd"
                      placeholder="End Time"
                      @change="change_cur_menu()"
                    >
                      <el-option v-for="tm in tmlist" :key="tm" :label="tm" :value="tm"></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col cols="3">
                  <el-tooltip content="1: first use, 9:last use" placement="top">
                    <el-form-item size="mini" :label="$t('EMenu Sequence')">
                      <el-input
                        placeholder="EMenu Sequence"
                        v-model="cur_menu.menuOrder"
                        @change="change_cur_menu()"
                        class="w-50"
                        size="mini"
                      ></el-input>
                    </el-form-item>
                  </el-tooltip>
                </b-col>
              </b-row> -->
              <b-row class="mb-1 mt-2" v-if="!isDraft" >
                <b-col cols="7" class="text-center">
                </b-col>
                <b-col cols="1" class="text-left">
                  <xlsx-workbook @change="function(sheet){change_for_menu(sheet, menu.IDn);}" @created="created_for_menu">
                    <xlsx-sheet
                      :collection="sheet.data"
                      v-for="sheet in export_sheets_for_menu"
                      :key="sheet.name"
                      :sheet-name="sheet.name"
                    />
                    <xlsx-download :filename="export_filename" disable-wrapper-click>
                      <template #default="{ download }">
                        <el-button
                          type="primary"
                          size="mini"
                          @click="export_menu(download)"
                        >
                          {{ $t("Export") }}
                        </el-button>
                      </template>
                    </xlsx-download>
                  </xlsx-workbook>
                </b-col>
                <b-col cols="1" class="text-left">
                  <el-button type="primary" size="mini" @click="menu_setting"> {{ $t("Setting") }} </el-button>
                </b-col>
                <b-col cols="1" v-if="hasLdwUpload && (cur_menu.IsOnline==1) && !isDraft" class="text-left">
                  <el-button type="primary" size="mini" @click="upload_ldw"> {{ $t("Update LDW") }} </el-button>
                </b-col>
                <b-col cols="1" v-if="hasLdwUpload && (cur_menu.IsOnline==1) && !isDraft" class="text-left">
                  <el-button type="danger" size="mini" @click="delete_menu"> {{ $t("Delete") }} </el-button>
                </b-col>
              </b-row>
              <hr class="page_hr" />
              <b-row class="mt-2">
                <b-col style="padding: 0;">
                  <label>{{ $t('Display Name') }} :</label>
                  <el-radio-group class="ml-1 mt-2" v-model="showLanguage">
                    <el-radio class="ml-1" label="1">{{ $t('Name') }}1</el-radio>
                    <el-radio class="ml-0" label="2">{{ $t('Name') }}2</el-radio>
                  </el-radio-group>
                  <div style="display: inline-block;">
                    <label class="pl-5">{{ $t('Operating') }} :</label>
                    <el-select
                      size="mini"
                      style="width: 50%"
                      v-model="cur_operating"
                      placeholder="Operating"
                      @change="select_current_Operating()"
                    >
                      <el-option :label="$t('No Operating')" :value="0"></el-option>
                      <el-option :label="$t('Add Product From Other Category')" :value="1"></el-option>
                      <el-option :label="$t('Change Button Color')" :value="2"></el-option>
                      <el-option :label="$t('Set Menu Color Template')" :value="3"></el-option>
                      <el-option :label="sorting_string(0)" :value="4">
                        <template #default>
                          <span v-html="sorting_string(0)"></span>
                        </template>
                      </el-option>
                      <el-option :label="sorting_string(1)" :value="5">
                        <template #default>
                          <span v-html="sorting_string(1)"></span>
                        </template>
                      </el-option>
                    </el-select>
                  </div>
                  <span class="ml-6">
                    <span v-if="cur_operating == 2" class="ml-2">
                      <el-color-picker :predefine="predefineColors" v-model="btnToColor" size="mini" class="menu-button-color"></el-color-picker>
                      Select Color
                      <b-button
                        variant="success"
                        size="sm"
                        @click="set_all_botton_color($event, 'all')"
                      >
                        Set All
                      </b-button>
                    </span>
                  </span>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col cols="7" class="mb-1">
                  <el-button v-if="isDraft" type="danger" size="large" @click="cancel_change()" style="font-size: 20px; padding: 10px 20px;">{{ $t('Cancel Change') }}</el-button>
                  <el-button v-if="isDraft" type="success" size="large" @click="save_change()" style="font-size: 20px; padding: 10px 20px;">{{ $t('Save Change') }}</el-button>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <div class="left_menu_font" :style="panel_left">
                  <div class="border border-dark pl-1">
                    {{ $t("Department") }}
                    <div v-if="cur_operating != 1" style="position: absolute;top:1px;right:0px;">
                      <!-- <i @click="remove_all('department')" class="el-icon-caret-left border border-success mr-1" style="font-size: 1rem; color: #2dce89"></i> -->
                      <i @click="add_all('department')" class="el-icon-d-arrow-right border border-success mr-3" style="font-size: 1rem; color: #2dce89"></i>
                    </div>
                  </div>
                  <div :class="panel_small?'department_div2':'department_div'">
                    <div v-for="prod in fulllist" :key="prod.IDn" class="border border-secondary" :class="{ 'border-info': cur_DepartmentIDn==prod.IDn}">
                      <div class="pl-1" style="position: relative;">
                        <div @click="select_product(prod.IDn, 'department')" v-if="showLanguage=='1'" :class="panel_small?'left_panel_sm_font':''" class="leftmenuitem">{{ prod.Name1 }}</div>
                        <div @click="select_product(prod.IDn, 'department')" v-else :class="panel_small?'left_panel_sm_font':''" class="leftmenuitem">{{ prod.Name2 }}</div>
                        <div v-if="prod.show && (cur_operating != 1)" @click="add_product(prod.IDn, 'department')" class="el-icon-caret-right border border-success m-1" style="position: absolute;top:1px;right:0px; color: #2dce89"></div>
                      </div>
                    </div>
                  </div>
                  <div class="border border-dark pl-1">
                    {{ $t("Category") }}
                    <div v-if="cur_operating != 1" style="position: absolute;top:1px;right:0px;">
                      <!-- <i @click="remove_all('category')" class="el-icon-caret-left border border-success mr-1" style="font-size: 1rem; color: #2dce89"></i> -->
                      <i @click="add_all('category')" class="el-icon-d-arrow-right border border-success mr-3" style="font-size: 1rem; color: #2dce89"></i>
                    </div>
                  </div>
                  <div :class="panel_small?'category_div2':'category_div'">
                    <div v-for="prod in leftcategory" :key="prod.IDn" class="border border-secondary" :class="{ 'border-info': cur_CategoryIDn==prod.IDn}">
                      <div class="d-flex pl-1">
                        <div @click="select_product(prod.IDn, 'category')" v-if="showLanguage=='1'" :class="panel_small?'left_panel_sm_font':''" class="leftmenuitem">{{ prod.Name1 }}</div>
                        <div @click="select_product(prod.IDn, 'category')" v-else :class="panel_small?'left_panel_sm_font':''" class="leftmenuitem">{{ prod.Name2 }}</div>
                        <div v-if="prod.show && (cur_operating != 1)" @click="add_product(prod.IDn, 'category')" class="el-icon-caret-right ml-auto border border-success m-1" style="color: #2dce89"></div>
                      </div>
                    </div>
                  </div>
                  <div class="border border-dark pl-1">
                    {{ $t("Product") }}
                    <div v-if="cur_operating != 1" style="position: absolute;top:1px;right:0px;">
                      <i @click="remove_all('product')" class="el-icon-d-arrow-left border border-success mr-1" style="font-size: 1rem; color: #2dce89"></i>
                      <i @click="add_all('product')" class="el-icon-d-arrow-right border border-success mr-1" style="font-size: 1rem; color: #2dce89"></i>
                    </div>
                  </div>
                  <div :class="panel_small?'product_div2':'product_div'">
                    <div v-for="prod in leftproduct" :key="prod.IDn" class="border border-secondary" :class="{ 'border-info': cur_ProductIDn==prod.IDn}">
                      <div v-if="prod.Status !== 'Deactive'" class="d-flex pl-1">
                        <div @click="select_product(prod.IDn, 'product')" v-if="showLanguage=='1'" :class="panel_small?'left_panel_sm_font':''" class="leftmenuitem">{{ prod.Name1 }}</div>
                        <div @click="select_product(prod.IDn, 'product')" v-else :class="panel_small?'left_panel_sm_font':''" class="leftmenuitem">{{ prod.Name2 }}</div>
                        <div v-if="prod.show" @click="add_product(prod.IDn, 'product')" class="el-icon-caret-right ml-auto border border-success mt-1 mr-1" style="color: #2dce89"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="px-0 ml-2">
                  <div :class="panel_small?'pad_panel2':'pad_panel'" v-on:drop="drop($event)" v-on:dragover="allowDrop($event)">
                    <div
                      id="department_panel_id"
                      class="panel_list"
                      :style="department_list_size"
                    >
                      <MenuBtn
                        v-for="prod in curmenu_departmentlist"
                        :key="prod.idx"
                        draggable="true"
                        :selectedBtn="prod.DepartmentIDn==cur_DepartmentIDn"
                        :showLang="showLanguage"
                        :Name2="prod.Name2"
                        :Name1="prod.Name1"
                        :BtnColor="prod.BtnColor"
                        :mywidth="menuDeptBtnWidth"
                        :myheight="menuDeptBtnHeight"
                        :fontSize="menuDeptBtnFontSize"
                        :fontWeight="menuDeptBtnFontWeight"
                        :fontColor="menuDeptBtnFontColor"
                        @dragstart="drag($event, prod, 'department')"
                        @removeButton="remove_cur_department($event, prod)"
                        @click.native="edit_department($event, prod)"
                      >
                      </MenuBtn>
                    </div>
                    <div
                      class="hr-line"
                      id="department-hr"
                      draggable="true"
                      @dragstart="drag($event, null, 'dept_cate')"
                      >
                    </div>
                    <div
                      id="category_panel_id"
                      class="panel_list"
                      :style="category_list_size"
                    >
                      <MenuBtn
                        v-for="prod in curmenu_categorylist"
                        :key="prod.idx"
                        draggable="true"
                        :selectedBtn="prod.CategoryIDn==cur_CategoryIDn"
                        :showLang="showLanguage"
                        :Name2="prod.Name2"
                        :Name1="prod.Name1"
                        :BtnColor="prod.BtnColor"
                        :mywidth="menuCateBtnWidth"
                        :myheight="menuCateBtnHeight"
                        :fontSize="menuCateBtnFontSize"
                        :fontWeight="menuCateBtnFontWeight"
                        :fontColor="menuCateBtnFontColor"
                        @dragstart="drag($event, prod, 'category')"
                        @removeButton="remove_cur_category($event, prod)"
                        @click.native="edit_category($event, prod)"
                      >
                      </MenuBtn>
                    </div>
                    <div
                      class="hr-line"
                      id="category-hr"
                      draggable="true"
                      @dragstart="drag($event, null, 'cate_prod')"
                      >
                    </div>
                    <div
                      id="product_panel_id"
                      class="panel_list"
                      :style="product_list_size"
                      >
                      <MenuBtn
                        v-for="prod in curmenu_productlist"
                        :key="prod.idx"
                        draggable="true"
                        :selectedBtn="prod.ProductIDn==cur_ProductIDn"
                        :showLang="showLanguage"
                        :Name2="prod.Name2"
                        :Name1="prod.Name1"
                        :BtnColor="prod.BtnColor"
                        :mywidth="menuProdBtnWidth"
                        :myheight="menuProdBtnHeight"
                        :fontSize="menuProdBtnFontSize"
                        :fontWeight="menuProdBtnFontWeight"
                        :fontColor="menuProdBtnFontColor"
                        @dragstart="drag($event, prod, 'product')"
                        @removeButton="remove_cur_product($event, prod)"
                        @click.native="edit_product($event, prod)"
                      >
                      </MenuBtn>
                    </div>
                  </div>
                  <div class="pt-3">
                    <b-row>
                      <b-col> {{ $t("The sketch map is different from the actual display") }} </b-col>
                    </b-row>
                    <b-row>
                      <b-col> </b-col>
                      <b-col>
                        {{ $t("Department") }}
                      </b-col>
                      <b-col>
                        {{ $t("Category") }}
                      </b-col>
                      <b-col>
                        {{ $t("Product") }}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-right">
                        {{ $t("Rows") }}
                      </b-col>
                      <b-col>
                        <el-input-number v-model="cur_menu.DepartmentRow" @change="change_cur_menu('department')" size="mini" :min="1" :max="9"></el-input-number>
                      </b-col>
                      <b-col>
                        <el-input-number v-model="cur_menu.CategoryRow" @change="change_cur_menu('category')" size="mini" :min="1" :max="9"></el-input-number>
                      </b-col>
                      <b-col>
                        <el-input-number v-model="cur_menu.ProductRow" @change="change_cur_menu('product')" size="mini" :min="1" :max="9"></el-input-number>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-right">
                        {{ $t("Cols") }}
                      </b-col>
                      <b-col>
                        <el-input-number v-model="cur_menu.DepartmentColumn" @change="change_cur_menu('department')" size="mini" :min="1" :max="9"></el-input-number>
                      </b-col>
                      <b-col>
                        <el-input-number v-model="cur_menu.CategoryColumn" @change="change_cur_menu('category')" size="mini" :min="1" :max="9"></el-input-number>
                      </b-col>
                      <b-col>
                        <el-input-number v-model="cur_menu.ProductColumn" @change="change_cur_menu('product')" size="mini" :min="1" :max="9"></el-input-number>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-right">
                        Font Size
                      </b-col>
                      <b-col>
                        <el-select v-model="cur_menu.DepartmentFontSize" @change="change_cur_menu('department')" size="mini">
                          <el-option v-for="item in fontSizeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                      </b-col>
                      <b-col>
                        <el-select v-model="cur_menu.CategoryFontSize" @change="change_cur_menu('category')" size="mini">>
                          <el-option v-for="item in fontSizeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                      </b-col>
                      <b-col>
                        <el-select v-model="cur_menu.ProductFontSize" @change="change_cur_menu('product')" size="mini">>
                          <el-option v-for="item in fontSizeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-right">
                        Font Weight
                      </b-col>
                      <b-col>
                        <el-select v-model="cur_menu.DepartmentFontWeight" @change="change_cur_menu('department')" size="mini">>
                          <el-option v-for="item in fontWeightList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                      </b-col>
                      <b-col>
                        <el-select v-model="cur_menu.CategoryFontWeight" @change="change_cur_menu('category')" size="mini">>
                          <el-option v-for="item in fontWeightList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                      </b-col>
                      <b-col>
                        <el-select v-model="cur_menu.ProductFontWeight" @change="change_cur_menu('product')" size="mini">>
                          <el-option v-for="item in fontWeightList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-right">
                        Font Color
                      </b-col>
                      <b-col>
                        <el-color-picker :predefine="predefineColors" v-model="cur_menu.DepartmentFontColor" size="small" @change="change_cur_menu('department')"></el-color-picker>
                      </b-col>
                      <b-col>
                        <el-color-picker :predefine="predefineColors" v-model="cur_menu.CategoryFontColor" size="small" @change="change_cur_menu('category')"></el-color-picker>
                      </b-col>
                      <b-col>
                        <el-color-picker :predefine="predefineColors" v-model="cur_menu.ProductFontColor" size="small" @change="change_cur_menu('product')"></el-color-picker>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-right">
                        Button Color
                      </b-col>
                      <b-col>
                        <el-color-picker :predefine="predefineColors" v-model="btnDToColor" size="small" @change="set_all_botton_color($event, 'department')"></el-color-picker>
                      </b-col>
                      <b-col>
                        <el-color-picker :predefine="predefineColors" v-model="btnCToColor" size="small" @change="set_all_botton_color($event, 'category')"></el-color-picker>
                      </b-col>
                      <b-col>
                        <el-color-picker :predefine="predefineColors" v-model="btnPToColor" size="small" @change="set_all_botton_color($event, 'product')"></el-color-picker>
                      </b-col>
                    </b-row>
                 </div>
                </div>
              </b-row>
            </el-form>
          </b-card>
        </el-tab-pane>

        <el-tab-pane :label="$t('New Menu')" name="add">
          <b-card>
            <el-form ref="form">
              <b-row class="mb-1">
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Name') + '1' }}
                    </el-col>
                    <el-col :span="12">
                      <el-input
                        v-model="cur_menu.Name1"
                        size="mini"
                      ></el-input>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Name') + '2' }}
                    </el-col>
                    <el-col :span="12">
                      <el-input
                        v-model="cur_menu.Name2"
                        size="mini"
                      ></el-input>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Price Group') }}
                    </el-col>
                    <el-col :span="12">
                      <el-select
                        size="mini"
                        v-model="cur_menu.PriceGroup"
                        placeholder="Price Group"
                      >
                        <el-option label="A" value="A"></el-option>
                        <el-option label="B" value="B"></el-option>
                        <el-option label="C" value="C"></el-option>
                        <el-option label="D" value="D"></el-option>
                        <el-option label="E" value="E"></el-option>
                        <el-option label="F" value="F"></el-option>
                        <el-option label="G" value="G"></el-option>
                        <el-option label="H" value="H"></el-option>
                        <el-option label="I" value="I"></el-option>
                        <el-option label="J" value="J"></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Get All Products') }}
                    </el-col>
                    <el-col :span="12">
                      <el-switch
                        v-model="new_menu_get_all"
                        active-value="1"
                        inactive-value="0"
                      ></el-switch>
                    </el-col>
                  </el-row>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Department Rows') }}
                    </el-col>
                    <el-col :span="12">
                      <el-input-number
                        v-model="cur_menu.DepartmentRow"
                        :min="1"
                        :max="9"
                        size="mini"
                      ></el-input-number>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Department Cols') }}
                    </el-col>
                    <el-col :span="12">
                      <el-input-number
                        v-model="cur_menu.DepartmentColumn"
                        :min="1"
                        :max="9"
                        size="mini"
                      ></el-input-number>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Category Rows') }}
                    </el-col>
                    <el-col :span="12">
                      <el-input-number
                        v-model="cur_menu.CategoryRow"
                        :min="1"
                        :max="9"
                        size="mini"
                      ></el-input-number>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Category Cols') }}
                    </el-col>
                    <el-col :span="12">
                      <el-input-number
                        v-model="cur_menu.CategoryColumn"
                        :min="1"
                        :max="9"
                        size="mini"
                      ></el-input-number>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Product Rows') }}
                    </el-col>
                    <el-col :span="12">
                      <el-input-number
                        v-model="cur_menu.ProductRow"
                        :min="1"
                        :max="9"
                        size="mini"
                      ></el-input-number>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Product Cols') }}
                    </el-col>
                    <el-col :span="12">
                      <el-input-number
                        v-model="cur_menu.ProductColumn"
                        :min="1"
                        :max="9"
                        size="mini"
                      ></el-input-number>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                </b-col>
              </b-row>

              <b-row class="mt-3">
                <b-col cols="9">
                  <el-row :gutter="20">
                    <el-col :span="4" class="text-right">
                      {{ $t('Store') }}
                    </el-col>
                    <el-col :span="20">
                      <el-checkbox-group
                        v-model="cur_menu.LocationID"
                        class="ml-2"
                      >
                        <el-checkbox
                          v-for="store in storelist"
                          :key="store.LocationID"
                          :label="store.LocationID"
                          >{{ store.LocationName }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-button type="primary" @click="add_menu()" size="medium">{{ $t("Create") }}</el-button>
                    </el-col>
                  </el-row>
                </b-col>
              </b-row>
            </el-form>
          </b-card>
          <b-card :title="$t('Copy Menu')">
            <el-form ref="form">
              <b-row class="mb-1">
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Menu') }}
                    </el-col>
                    <el-col :span="12">
                      <el-select
                        size="mini"
                        v-model="copy_Menu_IDn"
                      >
                        <el-option v-for="menu in menulist" :key="menu.IDn" :label="menu.Name1" :value="menu.IDn"></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Name') + '1' }}
                    </el-col>
                    <el-col :span="12">
                      <el-input
                        v-model="copy_Name1"
                        size="mini"
                      ></el-input>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Name') + '2' }}
                    </el-col>
                    <el-col :span="12">
                      <el-input
                        v-model="copy_Name2"
                        size="mini"
                      ></el-input>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-button type="primary" @click="copy_menu()" size="medium">{{ $t("Copy") }}</el-button>
                    </el-col>
                  </el-row>
                </b-col>
              </b-row>
            </el-form>
          </b-card>
          <b-card v-if="pkadmin" :title="$t('Copy Price Group')">
            <el-form ref="form">
              <b-row class="mb-1">
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Price Group') }}
                    </el-col>
                    <el-col :span="12">
                      <el-select
                        size="mini"
                        v-model="copy_PriceF"
                        placeholder="Price Group"
                      >
                        <el-option label="A" value="A"></el-option>
                        <el-option label="B" value="B"></el-option>
                        <el-option label="C" value="C"></el-option>
                        <el-option label="D" value="D"></el-option>
                        <el-option label="E" value="E"></el-option>
                        <el-option label="F" value="F"></el-option>
                        <el-option label="G" value="G"></el-option>
                        <el-option label="H" value="H"></el-option>
                        <el-option label="I" value="I"></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      To
                    </el-col>
                    <el-col :span="12">
                      <el-select
                        size="mini"
                        v-model="copy_PriceT"
                        placeholder="Price Group"
                      >
                        <el-option label="B" value="B"></el-option>
                        <el-option label="C" value="C"></el-option>
                        <el-option label="D" value="D"></el-option>
                        <el-option label="E" value="E"></el-option>
                        <el-option label="F" value="F"></el-option>
                        <el-option label="G" value="G"></el-option>
                        <el-option label="H" value="H"></el-option>
                        <el-option label="I" value="I"></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <el-button type="primary" @click="copy_price()" size="medium">{{ $t("Copy") }}</el-button>
                    </el-col>
                  </el-row>
                </b-col>
              </b-row>
            </el-form>
          </b-card>
          <b-card :title="$t('Import')">
            <el-form ref="form">
              <b-row class="mb-1">
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="12" class="text-right">
                      {{ $t('Overwrite menu') }}
                    </el-col>
                    <el-col :span="12">
                      <el-switch
                        v-model="import_overwrite"
                        active-value="1"
                        inactive-value="0"
                      ></el-switch>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10" v-if="import_overwrite == 1">
                    <el-col :span="12" class="text-right">
                      {{ $t('Menu') }}
                    </el-col>
                    <el-col :span="12">
                      <el-select
                        size="mini"
                        v-model="overwrite_Menu_IDn"
                      >
                        <el-option v-for="menu in menulist" :key="menu.IDn" :label="menu.Name1" :value="menu.IDn"></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                </b-col>
                <b-col cols="3">
                </b-col>
                <b-col cols="3">
                  <el-row :gutter="10">
                    <el-col :span="6">
                      <input ref="fileuploader" type="file" @change="on_import_change" @click="reset_import_file"/>
                      <xlsx-read :file="import_file" @parsed="import_file_parsed">
                      </xlsx-read>
                    </el-col>
                  </el-row>
                </b-col>
              </b-row>
            </el-form>
          </b-card>
        </el-tab-pane>
      </el-tabs>
    </b-container>
    <el-dialog title="Upload Image File" :visible.sync="upload_product_dialog" width="30%">
      <div class="upload_product_div" id="upload_product_ref">
        <div v-for="(row,idx) in upload_file_list" :key="idx">{{ row }}</div>
      </div>
      <div slot="footer">
        <el-button v-if="upload_show_close" @click="upload_product_dialog = false">OK</el-button>
      </div>
    </el-dialog>
    <el-dialog title="Select Menu Color Template" :visible.sync="showTemplateList" width="50%">
      <div class="template-class">
        <MenuTemplate class="template-sub" v-for="(tpl, idx) in templateList" :key="idx" :tplColors="tpl" @tplsave="setTemplate"></MenuTemplate>
      </div>
      <div slot="footer">
        <el-button @click="closeTemplate">Cancel</el-button>
      </div>
    </el-dialog>
    <vue-element-loading
      :active="showloading"
      spinner="bar-fade-scale"
      color="#FF6700"
      duration="2.0"
      background-color="rgba(255, 255, 255, .5)"
      size="100"
    />
  </div>
</template>
<script>
import {
  Form,
  Tabs,
  TabPane,
  Button,
  Checkbox,
  CheckboxGroup,
  FormItem,
  Select,
  Option,
  InputNumber,
  Tag,
  Switch,
  Row,
  Dialog,
  Col,
  Radio,
  RadioGroup,
  ColorPicker,
  DatePicker,
} from "element-ui";
import "flatpickr/dist/flatpickr.css";
import MenuBtn from "../Components/MenuBtn";
import MenuTemplate from "../Components/MenuTemplate";
import { getStore, setStore } from "../../util/helper";
import VueElementLoading from "vue-element-loading";
import { XlsxRead, XlsxWorkbook, XlsxSheet, XlsxDownload } from "vue-xlsx";

const axios = require("axios");

export default {
  components: {
    [Form.name]: Form,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [InputNumber.name]: InputNumber,
    [Tag.name]: Tag,
    [Switch.name]: Switch,
    [Row.name]: Row,
    [Dialog.name]: Dialog,
    [Col.name]: Col,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [ColorPicker.name]: ColorPicker,
    [DatePicker.name]: DatePicker,
    MenuBtn,
    MenuTemplate,
    VueElementLoading,
    XlsxRead,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    return {
      showloading: false,
      panel_small: false,

      active_tab: "",
      new_menu_get_all: 0,
      isDraft: 0,
      cur_idx: 1,       // Right menu key index, for drew control

      currpage: "list",
      cur_opt: null,

      predefineColors: ['#DFB9FC','#EBAE6C','#6AE7E7','#FFE100','#00FE25','#F37F76','#43D5E2'],
      tmlist: [
        '00:00','00:30',
        '01:00','01:30',
        '02:00','02:30',
        '03:00','03:30',
        '04:00','04:30',
        '05:00','05:30',
        '06:00','06:30',
        '07:00','07:30',
        '08:00','08:30',
        '09:00','09:30',
        '10:00','10:30',
        '11:00','11:30',
        '12:00','12:30',
        '13:00','13:30',
        '14:00','14:30',
        '15:00','15:30',
        '16:00','16:30',
        '17:00','17:30',
        '18:00','18:30',
        '19:00','19:30',
        '20:00','20:30',
        '21:00','21:30',
        '22:00','22:30',
        '23:00','23:30',
        '24:00',
      ],

      hasLdwUpload: false,
      upload_product_dialog: false,
      upload_file_ids: [],
      upload_file_cnt: 0,
      upload_file_list: [],
      upload_show_close: false,

      showLanguage: "1",
      fontSizeList: [{value:14,label:'14px'},{value:16,label:'16px'},{value:18,label:'18px'},{value:24,label:'24px'},{value:28,label:'28px'},{value:32,label:'32px'},],
      fontWeightList: [{value:400,label:'Normal'},{value:500,label:'Normal +'},{value:600,label:'Bold -'},{value:700,label:'Bold'},{value:800,label:'Bold +'},],

      cur_menu: {   // Menu Meta Data Record
        IDn: "",
        Name1: "",
        Name2: "",
        Remarks: "",
        PanelWidth: 674,
        PanelHeigh: 663,
        DepartmentHeight: 39,
        CategoryHeight: 117,
        ProductHeight: 507,
        DepartmentRow: 1,
        DepartmentColumn: 5,
        DepartmentFontSize: 14,
        DepartmentFontWeight: 400,
        DepartmentFontColor: '#000000',
        CategoryRow: 3,
        CategoryColumn: 5,
        CategoryFontSize: 14,
        CategoryFontWeight: 400,
        CategoryFontColor: '#000000',
        ProductRow: 5,
        ProductColumn: 5,
        ProductFontSize: 14,
        ProductFontWeight: 400,
        ProductFontColor: '#000000',
        PriceGroup: "A",
        LocationID: [],
        TaxGroupIDn: [],
        HourTable: "",
        IsOnline: 0,
        IsEMenu: 0,
        StartDate: "2021-01-01",
        EndDate: "2031-01-01",
        Status: 1,
        menuOrder: 10,
        menuTimeControl: 0,
        menuStart: '',
        menuEnd: '',
        mustHave: 0,
        mustHaveStart: '',
        mustHaveEnd: '',
        mustHaveWarrning: '',
      },
      new_menu: {
        IDn: "",
        Name1: "",
        Name2: "",
        Remarks: "",
        PanelWidth: 674,
        PanelHeigh: 663,
        DepartmentHeight: 39,
        CategoryHeight: 117,
        ProductHeight: 507,
        DepartmentRow: 1,
        DepartmentColumn: 5,
        DepartmentFontSize: 14,
        DepartmentFontWeight: 400,
        DepartmentFontColor: '#000000',
        CategoryRow: 3,
        CategoryColumn: 5,
        CategoryFontSize: 14,
        CategoryFontWeight: 400,
        CategoryFontColor: '#000000',
        ProductRow: 5,
        ProductColumn: 5,
        ProductFontSize: 14,
        ProductFontWeight: 400,
        ProductFontColor: '#000000',
        PriceGroup: "A",
        LocationID: [],
        TaxGroupIDn: [],
        HourTable: "",
        IsOnline: 0,
        IsEMenu: 0,
        StartDate: "2021-01-01",
        EndDate: "2031-01-01",
        Status: 1,
        menuOrder: 10,
        menuTimeControl: 0,
        menuStart: '',
        menuEnd: '',
        mustHave: 0,
        mustHaveStart: '',
        mustHaveEnd: '',
        mustHaveWarrning: '',
      },
      cur_product: {
        Name1: "",
        Name2: "",
      },
      curmenu_product: {
        Price: 0,
        DiscountPrice: 0,
        BtnColor: "#cad1d7",
        Quantity: 1000,
        SortOrder: 999,
        Soldout: 1,
      },

      menulist: null,                 // All Menu basic record list
      fulllist: null,                 // Array structure!! All Product list under sorted department and category
      leftcategory: null,             // pointer!! Left active category pointer
      leftproduct: null,
      curmenu_departmentlist: [],   // Array structure!! Right Menu Structed data list and for for department display
      curmenu_categorylist: [],     // pointer!! Right Menu for category display
      curmenu_productlist: [],      // pointer!! Right Menu for product display

      cur_MenuIDn: 0,           // Active Menu IDn
      cur_DepartmentIDn: 0,     // Selected Department IDn, For display css control
      cur_CategoryIDn: 0,       // Selected Category IDn, For display css control
      cur_ProductIDn: 0,        // Selected Product IDn, For display css control

      storelist: null,
      statuses: [],
      onlineList: [],

      cur_operating: 0,        // 0: no operating; 1: try to add other product to current category; 2: Change Button Color;

      Original_DepartmentIDn: 0,
      Original_CategoryIDn: 0,

      copy_Name1: "",
      copy_Name2: "",
      copy_Menu_IDn: null,
      copy_PriceF: "A",
      copy_PriceT: "B",

      dismessage: "",
      countdown: 0,

      PanelWidth: 690,  // Add scroll bar 674 + 6
      PanelHeigh: 665,  // Add divider bar 663 + 2

      menuDeptBtnWidth: 151,
      menuDeptBtnHeight: 60,
      menuDeptBtnFontSize: 16,
      menuDeptBtnFontWeight: 400,
      menuDeptBtnFontColor: "#7BF58D",
      menuCateBtnWidth: 200,
      menuCateBtnHeight: 100,
      menuCateBtnFontSize: 16,
      menuCateBtnFontWeight: 400,
      menuCateBtnFontColor: "#7BF58D",
      menuProdBtnWidth: 200,
      menuProdBtnHeight: 100,
      menuProdBtnFontSize: 16,
      menuProdBtnFontWeight: 400,
      menuProdBtnFontColor: "#7BF58D",

      btnToColor: "#FFDAB8",
      btnDToColor: "#FFCE76",
      btnCToColor: "#FF865B",
      btnPToColor: "#FFDAB8",

      department_list_size: { width: '690px', height: '39px',},
      category_list_size: { width: '690px', height: '117px',},
      product_list_size: { width: '690px', height: '500px',},
      btnselectstyle: { backgroundColor: "#cad1d7" },
      panel_left: { width: '116px'},

      movingtype: null,
      movingevt: null,
      movingprod: null,
      movingleft: 0,
      movingtop: 0,

      sync_to_server: null,

      new_menu_department: {
        IDn: 0,
        Name1: "",
        Name2: "",
        MenuIDn: 0,
        DepartmentIDn: 0,
        Categorys: [],
        BtnColor: '#FFCE76',
        SortOrder: 999,
      },
      new_menu_category: {
        IDn: 0,
        Name1: "",
        Name2: "",
        MenuIDn: 0,
        DepartmentIDn: 0,
        CategoryIDn: 0,
        Products: [],
        BtnColor: '#FF865B',
        SortOrder: 999,
      },
      new_menu_product: {
        IDn: 0,
        Name1: "",
        Name2: "",
        MenuIDn: 0,
        DepartmentIDn: 0,
        CategoryIDn: 0,
        ProductIDn: 0,
        AltCategoryIDn: 0,
        BtnColor: '#FFDAB8',
        SortOrder: 999,
      },

      templateList: [
        { department: '#FFCE76', category: '#FF865B', product: '#FFDAB8' },
        { department: '#D96A29', category: '#D99E6A', product: '#BAD9D3' },
        { department: '#D49B57', category: '#D9BF5D', product: '#D18354' },
        { department: '#E7A97A', category: '#E59578', product: '#DBB57B' },
        { department: '#63D6A1', category: '#DFC87E', product: '#CB9C8A' },
        { department: '#F2B8A4', category: '#F2DBB4', product: '#F7EBD9' },
        { department: '#F6AB8E', category: '#FFCDB6', product: '#FFE1DB' },
        { department: '#A8D6E5', category: '#D2E9E3', product: '#E5EFF0' },
        { department: '#D7D1DF', category: '#CDB1D8', product: '#DBD5F9' },
        { department: '#6B94F3', category: '#7AC4F5', product: '#BCA8D7' },
        { department: '#5ECDD9', category: '#64D8A2', product: '#79B8E8' },
      ],
      showTemplateList: false,

      pkadmin: false,

      token: "",
      user_id: 0,

      // export
      export_sheets_for_menu: [{ name: "menu", data: [[1,2,3,4],[5,6,7,8]] }],
      callback_for_menu: "",
      export_filename: "",
      // import
      import_file: null,
      import_overwrite: 0,
      overwrite_Menu_IDn: 0,
    };
  },
  computed: {},
  watch: {
    // cur_MenuIDn: function (nval, oval) {
    // },
  },
  methods: {
    setTemplate(tpl) {
      // console.log("Menu.vue setTemplate", tpl);
      this.showloading = true;
      for (var i = 0; i < this.curmenu_departmentlist.length; i++) {
        var dpt = this.curmenu_departmentlist[i];
        dpt.BtnColor = tpl.department;
        for (var j = 0; j < dpt.Categorys.length; j++) {
          var cat = dpt.Categorys[j];
          cat.BtnColor = tpl.category;
          for (var k = 0; k < cat.Products.length; k++) {
            var prd = cat.Products[k];
            prd.BtnColor = tpl.product;
          }
        }
      }
      this.resize_buttons();
      this.showloading = false;
      this.closeTemplate();
      this.change_cur_menu();
    },
    closeTemplate() {
      this.showTemplateList = false;
      this.cur_operating = 0;
    },
    // Drop All Changes and get Current Menu again
    cancel_change() {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("MenuIDn", this.cur_MenuIDn);
      this.cur_operating = 0;
      this.select_current_Operating();

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/menu/cancel_change",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_MenuIDn = rt.data.MenuIDn;
              that.isDraft = 0;
              that.getcur_menu();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    // Confirm all Changes and get Current Menu again
    save_change() {
      this.showloading = true;
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("MenuIDn", this.cur_MenuIDn);
      bodyFormData.append("Menu", JSON.stringify(this.cur_menu));
      bodyFormData.append("Departments", JSON.stringify(this.curmenu_departmentlist));
      this.cur_operating = 0;
      this.select_current_Operating();

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/menu/save_menu",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_MenuIDn = rt.data.MenuIDn;
              that.getcur_menu();
              // that.$router.go();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          that.showloading = false;
          // console.log(error);
          that.$router.push("/login");
        });
    },
    // Update sheet data when changed Menu ???
    change_for_menu(sheet, menu_id) {
      // change event will emit twice when sheets is set, xlsx sheets is set to empty at first event, then xlsx sheets is set to the new sheets.
      if (this.callback_for_menu && sheet.SheetNames && sheet.SheetNames.length > 0) {
        // if multiple tabs are activated, there will be multiple download components, and this function will be triggered redundently
        // so use the menu id to distinguish.
        if (menu_id == this.cur_MenuIDn) {
          this.callback_for_menu();
        }
      }
    },
    created_for_menu() {
      this.callback_for_menu = '';
    },
    export_menu(callback) {
      this.export_sheets_for_menu[0].data = this.generate_excel_data();
      this.callback_for_menu = callback;
    },
    menu_setting() {
      this.$router.push({path: "/menu_setting", query: {menu_id: this.cur_MenuIDn}});
    },
    // generate sheet data when changed Menu ???
    generate_excel_data() {
      var today = new Date();
      let todaystr = today.getFullYear() + '_' + String(today.getMonth() + 1).padStart(2, '0') + '_' + String(today.getDate()).padStart(2, '0');
      this.export_filename = this.cur_menu.Name1 + '_' + this.cur_menu.Name2 + '_' + todaystr;
      let excel_data = [];
      excel_data.push(["Menu", JSON.stringify(this.cur_menu)]);
      excel_data.push(["Departments", JSON.stringify(this.curmenu_departmentlist)]);
      return excel_data;
    },
    // import
    on_import_change(event) {
      this.import_file = event.target.files ? event.target.files[0] : null;
    },
    reset_import_file() {
      this.import_file = null;
      this.$refs.fileuploader.value = '';
    },
    import_file_parsed(filedata) {
      this.reset_import_file();

      if (!confirm("Are you sure to import the file?")) {
        return;
      }

      if (this.import_overwrite == 1 && this.overwrite_Menu_IDn == 0) {
        alert("Please select menu to overwrite");
        return;
      }

      this.selected_product_list = [];
      var sheets = filedata.Sheets[Object.keys(filedata.Sheets)[0]];
      var A1 = sheets["A1"] != undefined ? sheets["A1"].w.trim() : "";
      var B1 = sheets["B1"] != undefined ? sheets["B1"].w.trim() : "";   // menu
      var A2 = sheets["A2"] != undefined ? sheets["A2"].w.trim() : "";
      var B2 = sheets["B2"] != undefined ? sheets["B2"].w.trim() : "";   // Departments

      if (A1 != "Menu" || A2 != "Departments") {
        alert("Wrong file");
        return;
      }

      try {
        JSON.parse(B1);
        JSON.parse(B2);
      } catch (err) {
        alert("File content wrong");
        return;
      }

      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("Menu", B1);
      bodyFormData.append("Departments", B2);
      bodyFormData.append("overwrite_Menu_IDn", this.import_overwrite == 1 ? this.overwrite_Menu_IDn : 0);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/menu/import_menu",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_MenuIDn = rt.data.MenuIDn;
              that.get_menu_list();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    // Remove department from Right menu
    remove_cur_department(ev, dpt) {
      ev.preventDefault();
      if (dpt.Categorys && dpt.Categorys.length > 0) {
        alert("Must Remove All Sub-Category First!")
        return;
      }
      if (this.showloading || (this.cur_operating == 1)) {
        // Add for protect save meun
        return;
      }

      var idx = this.find_cur_department(dpt.DepartmentIDn);
      if (idx < 0) {
        alert("Some thing wrong, can't find department!")
        return;
      }
      this.curmenu_departmentlist.splice(idx,1);
      this.change_cur_menu();
      idx = this.find_department(dpt.DepartmentIDn);
      if (idx < 0) {
        return;
      }
      this.fulllist[idx].show = 1;
      if (this.curmenu_departmentlist.length > 0) {
        this.edit_department(ev, this.curmenu_departmentlist[0]);
      }
    },
    // Remove category from Right menu
    remove_cur_category(ev, cat) {
      ev.preventDefault();
      if (cat.Products && cat.Products.length > 0) {
        alert("Must Remove All Sub-Product First!")
        return;
      }
      var dptidx = this.find_cur_department(cat.DepartmentIDn);
      if (dptidx < 0) {
        alert("Some thing wrong, can't find department!")
        return;
      }
      if (this.showloading || (this.cur_operating == 1)) {
        // Add for protect save meun
        return;
      }

      var idx = this.find_cur_category(this.curmenu_departmentlist[dptidx].Categorys, cat.CategoryIDn);
      if (idx < 0) {
        alert("Some thing wrong, can't find category!")
        return;
      }
      this.curmenu_departmentlist[dptidx].Categorys.splice(idx,1);
      this.change_cur_menu();

      dptidx = this.find_department(cat.DepartmentIDn);
      if (dptidx < 0) {
        return;
      }
      idx = this.find_category(this.fulllist[dptidx].Categorys, cat.CategoryIDn);
      if (idx < 0) {
        return;
      }
      this.fulllist[dptidx].Categorys[idx].show = 1;
      if (this.curmenu_departmentlist[dptidx].Categorys.length > 0) {
        this.edit_category(ev, this.curmenu_departmentlist[dptidx].Categorys[0]);
      }
    },
    // Remove product from Right menu
    remove_cur_product(ev, prd) {
      ev.preventDefault();

      var dptidx = this.find_cur_department(prd.DepartmentIDn);
      if (dptidx < 0) {
        alert("Some thing wrong, can't find department!")
        return;
      }
      var catidx = this.find_cur_category(this.curmenu_departmentlist[dptidx].Categorys, prd.CategoryIDn);
      if (catidx < 0) {
        alert("Some thing wrong, can't find category!")
        return;
      }
      if (this.showloading || (this.cur_operating == 1)) {
        // Add for protect save meun
        return;
      }

      var idx = this.find_cur_product(this.curmenu_departmentlist[dptidx].Categorys[catidx].Products, prd.ProductIDn);
      if (idx < 0) {
        alert("Some thing wrong, can't find product!")
        return;
      }
      this.curmenu_departmentlist[dptidx].Categorys[catidx].Products.splice(idx,1);
      this.change_cur_menu();
      if (prd.AltCategoryIDn == prd.CategoryIDn) {
        var product = this.fullfind_product(prd.ProductIDn);
        if (product) {
          product.show = 1;
        }
      }
      if (this.curmenu_departmentlist[dptidx].Categorys[catidx].Products.length > 0) {
        this.edit_product(ev, this.curmenu_departmentlist[dptidx].Categorys[catidx].Products[0]);
      }
    },
    sorting_string(desc) {
      if (desc) {
        return this.$t('Sort Product By Name') + ' &dArr;';
      } else {
        return this.$t('Sort Product By Name') + ' &uArr;';
      }
    },
    sorting_product(desc) {
      if (this.curmenu_productlist.length>0) {
        if (this.showLanguage == '1') {
          if (desc) {
            this.curmenu_productlist.sort((a,b) => b.Name1.localeCompare(a.Name1));
          } else {
            this.curmenu_productlist.sort((a,b) => a.Name1.localeCompare(b.Name1));
          }
        } else {
          if (desc) {
            this.curmenu_productlist.sort((a,b) => b.Name2.localeCompare(a.Name2));
          } else {
            this.curmenu_productlist.sort((a,b) => a.Name2.localeCompare(b.Name2));
          }
        }
        for (var i = 0; i < this.curmenu_productlist.length; i++) {
          this.curmenu_productlist[i].SortOrder = i + 1;
        }
        this.change_cur_menu();
      }
    },
    close_alert() {
      this.countdown = 0;
      if (this.countdown == 0) {
        this.dismessage = "";
      }
    },
    select_current_Operating() {
      if (this.cur_operating == 3) {
        this.showTemplateList = true;
      } else if (this.cur_operating == 4) {
        this.sorting_product(0);
      } else if (this.cur_operating == 5) {
        this.sorting_product(1);
      } else {
        this.showTemplateList = false;
      }
      this.add_other_category();
    },
    // Toggle add product from other category mode
    add_other_category() {
      if (this.cur_operating == 1) {
        this.Original_DepartmentIDn = this.cur_DepartmentIDn;
        this.Original_CategoryIDn = this.cur_CategoryIDn;
      } else if (this.Original_DepartmentIDn > 0) {
        this.select_product(this.Original_DepartmentIDn, 'department');
        this.Original_DepartmentIDn = 0;
        this.Original_CategoryIDn = 0;
      }
    },
    // Base on current menu data, recaculate button size for right menu
    resize_buttons_department() {
      if (this.cur_MenuIDn > 0) {
        this.menuDeptBtnWidth = Math.floor(this.cur_menu.PanelWidth / this.cur_menu.DepartmentColumn);
        this.menuDeptBtnHeight = Math.floor(this.cur_menu.DepartmentHeight / this.cur_menu.DepartmentRow);
        this.menuDeptBtnFontSize = this.panel_small?(this.cur_menu.DepartmentFontSize/2):this.cur_menu.DepartmentFontSize;
        this.department_list_size.height = (this.cur_menu.DepartmentHeight) + 'px';
      } else {
        this.department_list_size.height = this.new_menu.DepartmentHeight + 'px';
      }
      this.menuDeptBtnFontWeight = this.cur_menu.DepartmentFontWeight;
      this.menuDeptBtnFontColor = this.cur_menu.DepartmentFontColor;
      this.set_menu_department_idx();
      // this.$nextTick(() => {
      // });
    },
    resize_buttons_category() {
      if (this.cur_MenuIDn > 0) {
        this.menuCateBtnWidth = Math.floor(this.cur_menu.PanelWidth / this.cur_menu.CategoryColumn);
        this.menuCateBtnHeight = Math.floor(this.cur_menu.CategoryHeight / this.cur_menu.CategoryRow);
        this.menuCateBtnFontSize = this.panel_small?(this.cur_menu.CategoryFontSize/2):this.cur_menu.CategoryFontSize;
        this.category_list_size.height = (this.cur_menu.CategoryHeight) + 'px';
      } else {
        this.category_list_size.height = this.new_menu.CategoryHeight + 'px';
      }
      this.menuCateBtnFontWeight = this.cur_menu.CategoryFontWeight;
      this.menuCateBtnFontColor = this.cur_menu.CategoryFontColor;
      this.set_menu_category_idx();
    },
    resize_buttons_product() {
      if (this.cur_MenuIDn > 0) {
        this.menuProdBtnWidth = Math.floor(this.cur_menu.PanelWidth / this.cur_menu.ProductColumn);
        this.menuProdBtnHeight = Math.floor(this.cur_menu.ProductHeight / this.cur_menu.ProductRow);
        this.menuProdBtnFontSize = this.panel_small?(this.cur_menu.ProductFontSize/2):this.cur_menu.ProductFontSize;
        this.product_list_size.height = (this.cur_menu.ProductHeight) + 'px';
      } else {
        this.product_list_size.height = this.new_menu.ProductHeight + 'px';
      }
      this.menuProdBtnFontWeight = this.cur_menu.ProductFontWeight;
      this.menuProdBtnFontColor = this.cur_menu.ProductFontColor;
      this.set_menu_product_idx();
    },
    resize_buttons() {
      this.resize_buttons_department();
      this.resize_buttons_category();
      this.resize_buttons_product();
    },
    // Process left menu item click event
    select_product(IDn, what) {
      if (what == "department") {
        this.cur_DepartmentIDn = IDn;
        // Left menu Department
        var midx = this.find_department(this.cur_DepartmentIDn);
        if (midx < 0) {
          alert("Department data error");
          this.cur_DepartmentIDn = 0;
          return;
        }
        this.leftcategory = this.fulllist[midx].Categorys;
        // Right menu Department
        if ((this.cur_operating != 1)) {
          var idx = this.find_cur_department(this.cur_DepartmentIDn);
          if (idx < 0) {
            // There is this depeartment data available
            this.curmenu_categorylist = [];
            this.curmenu_productlist = [];
            this.cur_CategoryIDn = 0;
            this.cur_ProductIDn = 0;
            return;
          }
          this.curmenu_categorylist = this.curmenu_departmentlist[idx].Categorys;
        }

        if (this.leftcategory.length > 0) {
          this.cur_CategoryIDn = this.leftcategory[0].IDn;
        } else {
          this.curmenu_categorylist = [];
          this.curmenu_productlist = [];
          this.cur_CategoryIDn = 0;
          this.cur_ProductIDn = 0;
          return;
        }
        // Left menu Category
        var midx1 = this.find_category(this.leftcategory, this.cur_CategoryIDn);
        if (midx1 < 0) {
          alert("Category data error");
          this.cur_CategoryIDn = 0;
          return;
        }
        this.leftproduct = this.leftcategory[midx1].Products;
        // Right menu Category
        if (this.cur_operating != 1) {
          var idx1 = this.find_cur_category(this.curmenu_categorylist, this.cur_CategoryIDn);
          if (idx1 < 0) {
            this.curmenu_productlist = [];
            this.cur_ProductIDn = 0;
            return;
          }
          this.curmenu_productlist = this.curmenu_categorylist[idx1].Products;

        }
        if (this.leftproduct.length > 0) {
          this.cur_ProductIDn = this.leftproduct[0].IDn;
          for (var i = 0; i < this.leftproduct.length; i++) {
            var idx1 = this.find_cur_product(this.curmenu_productlist, this.leftproduct[i].IDn);
            if (idx1 < 0) {
              this.leftproduct[i].show = 1;
            } else {
              this.leftproduct[i].show = 0;
            }
          }
        } else {
          this.curmenu_productlist = [];
          this.cur_ProductIDn = 0;
        }
      } else if (what == "category") {
        this.cur_CategoryIDn = IDn;
        // Left menu
        var midx1 = this.find_category(this.leftcategory, this.cur_CategoryIDn);
        if (midx1 < 0) {
          alert("Category data error");
          this.cur_CategoryIDn = 0;
          return;
        }
        this.leftproduct = this.leftcategory[midx1].Products;
        if (this.cur_operating != 1) {
          this.curmenu_productlist = [];
          // Right menu
          var idx1 = this.find_cur_category(this.curmenu_categorylist, this.cur_CategoryIDn);
          if (idx1 < 0) {
            this.curmenu_productlist = [];
            this.cur_ProductIDn = 0;
            return;
          }
          this.curmenu_productlist = this.curmenu_categorylist[idx1].Products;
          this.curmenu_productlist_cidx = idx1;
        }
        if (this.leftproduct.length > 0) {
          this.cur_ProductIDn = this.leftproduct[0].IDn;
          for (var i = 0; i < this.leftproduct.length; i++) {
            var idx1 = this.find_cur_product(this.curmenu_productlist, this.leftproduct[i].IDn);
            if (idx1 < 0) {
              this.leftproduct[i].show = 1;
            } else {
              this.leftproduct[i].show = 0;
            }
          }
        } else {
          this.cur_ProductIDn = 0;
        }
      } else if (what == "product") {
        this.cur_ProductIDn = IDn;
        if (this.leftproduct.length > 0) {
          for (var i = 0; i < this.leftproduct.length; i++) {
            var idx1 = this.find_cur_product(this.curmenu_productlist, this.leftproduct[i].IDn);
            if (idx1 < 0) {
              this.leftproduct[i].show = 1;
            } else {
              this.leftproduct[i].show = 0;
            }
          }
        }
      }
    },
    // Add product/category/department to right
    add_product(IDn, what, update=true) {
      // Add a product from
      if (what == "department") {
        if (this.cur_operating == 1) {
          alert("You are in add product from other category mode");
          return;
        }
        var didx = this.find_department(IDn);
        if (didx < 0) {
          alert("Department data error");
          return;
        }
        var dpt = this.fulllist[didx];
        var mdidx = this.find_cur_department(IDn);
        if (mdidx >= 0) {
          // Already add
          return;
        }
        dpt.show = 0;
        var mdpt = JSON.parse(JSON.stringify(this.new_menu_department));
        mdpt.Name1 = dpt.Name1;
        mdpt.Name2 = dpt.Name2;
        mdpt.MenuIDn = this.cur_MenuIDn;
        mdpt.DepartmentIDn = dpt.IDn;
        mdpt.BtnColor = this.btnDToColor;
        mdpt.SortOrder = this.curmenu_departmentlist.length + 1;
        mdpt.idx = this.cur_idx++;

        for (var i = 0; i < dpt.Categorys.length; i++) {
          var category = dpt.Categorys[i];
          category.show = 0;
          var mcat = JSON.parse(JSON.stringify(this.new_menu_category));
          mcat.Name1 = category.Name1;
          mcat.Name2 = category.Name2;
          mcat.MenuIDn = this.cur_MenuIDn;
          mcat.DepartmentIDn = category.DepartmentIDn;
          mcat.CategoryIDn = category.IDn;
          mcat.BtnColor = this.btnCToColor;
          mcat.SortOrder = i + 1;
          mcat.idx = this.cur_idx++;

          for (var j = 0; j < category.Products.length; j++) {
            var me = category.Products[j];
            me.show = 0;
            var mprd = JSON.parse(JSON.stringify(this.new_menu_product));
            mprd.Name1 = me.Name1;
            mprd.Name2 = me.Name2;
            mprd.MenuIDn = this.cur_MenuIDn;
            mprd.DepartmentIDn = me.DepartmentIDn;
            mprd.CategoryIDn = me.CategoryIDn;
            mprd.ProductIDn = me.IDn;
            mprd.AltCategoryIDn = me.CategoryIDn;
            mprd.BtnColor = this.btnPToColor;
            mprd.SortOrder = j + 1;
            mprd.idx = this.cur_idx++;

            mcat.Products.push(mprd);
          }
          mdpt.Categorys.push(mcat);
        }
        this.curmenu_departmentlist.push(mdpt);
      } if (what == "category") {
        if (this.cur_operating == 1) {
          alert("You are in add product from other category mode");
          return;
        }
        var cidx = this.find_category(this.leftcategory, IDn);
        if (cidx < 0) {
          alert("Category data error");
          return;
        }
        var category = this.leftcategory[cidx];
        var mcidx = this.find_cur_category(this.curmenu_categorylist, IDn);
        if (mcidx >= 0) {
          // Already add
          return;
        }

        let didx = this.find_department(category.DepartmentIDn);
        if (didx < 0) {
          alert("Category belongs to Department data error");
          return;
        }
        if (this.fulllist[didx].show) {
          alert("Add Department first");
          return;
        }

        category.show = 0;
        var mcat = JSON.parse(JSON.stringify(this.new_menu_category));
        mcat.Name1 = category.Name1;
        mcat.Name2 = category.Name2;
        mcat.MenuIDn = this.cur_MenuIDn;
        mcat.DepartmentIDn = category.DepartmentIDn;
        mcat.CategoryIDn = category.IDn;
        mcat.BtnColor = this.btnCToColor;
        mcat.SortOrder = this.curmenu_categorylist.length + 1;
        mcat.idx = this.cur_idx++;
        for (var j = 0; j < this.leftcategory[cidx].Products.length; j++) {
          var me = this.leftcategory[cidx].Products[j];
          me.show = 0;
          var mprd = JSON.parse(JSON.stringify(this.new_menu_product));
          mprd.Name1 = me.Name1;
          mprd.Name2 = me.Name2;
          mprd.MenuIDn = this.cur_MenuIDn;
          mprd.DepartmentIDn = me.DepartmentIDn;
          mprd.CategoryIDn = me.CategoryIDn;
          mprd.ProductIDn = me.IDn;
          mprd.AltCategoryIDn = me.CategoryIDn;
          mprd.BtnColor = this.btnPToColor;
          mprd.SortOrder = j + 1;
          mprd.idx = this.cur_idx++;
          mcat.Products.push(mprd);
        }
        this.curmenu_categorylist.push(mcat);
      } if (what == "product") {
        var idx = this.find_product(this.leftproduct, IDn);
        if (idx < 0) {
          alert("Product data error");
          return;
        }

        if (this.cur_operating != 1) {
          let cidx = this.find_category(this.leftcategory, this.cur_CategoryIDn);
          if (cidx < 0) {
            alert("Product belongs to Category data error");
            return;
          }
          if (this.leftcategory[cidx].show) {
            alert("Add Category first");
            return;
          }
        }

        var me = this.leftproduct[idx];
        me.show = 0;
        var pidx = this.find_cur_product(this.curmenu_productlist, IDn);
        if (pidx >= 0) {
          // Already add
          return;
        }
        var mprd = JSON.parse(JSON.stringify(this.new_menu_product));
        mprd.Name1 = me.Name1;
        mprd.Name2 = me.Name2;
        mprd.MenuIDn = this.cur_MenuIDn;
        if (this.cur_operating == 1) {
          mprd.DepartmentIDn = this.Original_DepartmentIDn;
          mprd.CategoryIDn = this.Original_CategoryIDn;
        } else {
          mprd.DepartmentIDn = me.DepartmentIDn;
          mprd.CategoryIDn = me.CategoryIDn;
        }
        mprd.ProductIDn = me.IDn;
        mprd.AltCategoryIDn = me.CategoryIDn;
        mprd.BtnColor = this.btnPToColor;
        mprd.SortOrder = this.curmenu_productlist.length + 1;
        mprd.idx = this.cur_idx++;
        this.curmenu_productlist.push(mprd);
      }
      if (update) {
        this.select_product(IDn, what)
        this.change_cur_menu();
      }
      // this.product_change("add", IDn, what);
    },
    allowDrop(ev) {
      ev.preventDefault();
      // console.log("allowDrop", ev);
    },
    // Drag Start from
    drag(ev, prod, movingtype) {
      if ((this.cur_operating == 1) || this.showloading) {
        this.movingtype = "disabled";
        return;
      }

      this.movingtype = movingtype; // product / category / department / dept_cate (line) / cate_prod (line) / disabled
      this.movingevt = ev;
      this.movingprod = prod;
      this.movingleft = ev.screenX;
      this.movingtop = ev.screenY;
      // console.log("drag1", ev);
    },
    // Drop change area event
    dropdiv(ev) {
      var offy = parseInt(ev.screenY - this.movingtop);
      this.cur_menu.DepartmentHeight = parseInt(this.cur_menu.DepartmentHeight);
      this.cur_menu.CategoryHeight = parseInt(this.cur_menu.CategoryHeight);
      this.cur_menu.ProductHeight = parseInt(this.cur_menu.ProductHeight);
      this.cur_menu.PanelHeigh = parseInt(this.cur_menu.PanelHeigh);
      if (this.movingtype == "dept_cate") {
        if (offy < 0) {
          // move up
          if ((offy + this.cur_menu.DepartmentHeight) < 0) {
            offy = -this.cur_menu.DepartmentHeight;
            this.cur_menu.DepartmentHeight = 0;
          } else {
            this.cur_menu.DepartmentHeight += offy;
          }
        } else {
          // move down
          if (offy > this.cur_menu.CategoryHeight) {
            offy = this.cur_menu.CategoryHeight;
          }
          this.cur_menu.DepartmentHeight += offy;
        }
        this.cur_menu.CategoryHeight -= offy;
        // console.log("dept_cate", offy);
        var adjy = this.cur_menu.DepartmentHeight + this.cur_menu.CategoryHeight + this.cur_menu.ProductHeight;
        if (this.cur_menu.PanelHeigh < adjy) {
          this.cur_menu.CategoryHeight -= adjy - this.cur_menu.PanelHeigh;
        }
        this.change_cur_menu();
      } else if (this.movingtype == "cate_prod") {
        if (offy < 0) {
          // move up
          if ((offy + this.cur_menu.CategoryHeight) < 0) {
            offy = -this.cur_menu.CategoryHeight;
            this.cur_menu.CategoryHeight = 0;
          } else {
            this.cur_menu.CategoryHeight += offy;
          }
        } else {
          // move down
          if (offy > this.cur_menu.ProductHeight) {
            offy = this.cur_menu.ProductHeight;
          }
          this.cur_menu.CategoryHeight += offy;
        }
        this.cur_menu.ProductHeight -= offy;
        // console.log("cate_prod", offy);
        var adjy = this.cur_menu.DepartmentHeight + this.cur_menu.CategoryHeight + this.cur_menu.ProductHeight;
        if (this.cur_menu.PanelHeigh < adjy) {
          this.cur_menu.ProductHeight -= adjy - this.cur_menu.PanelHeigh;
        }
        this.change_cur_menu();
      }
    },
    array_move(arr, old_index, new_index) {
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
    },
    // Drop event process
    drop(ev) {
      ev.preventDefault();
      if (this.movingtype == "disabled") {
        // Do nothing
        if (this.cur_operating == 1) {
          alert("You are in add product from other category mode");
        }
        return ;
      }

      if ((this.movingtype == "dept_cate") || (this.movingtype == "cate_prod")) {
        return this.dropdiv(ev);
      }

      this.showloading = true;
      var btnw, btnh, btncolumn;
      var curorder = 0;
      var curlist, len;
      if (this.movingtype == "department") {
        btnw = this.menuDeptBtnWidth;
        btnh = this.menuDeptBtnHeight;
        btncolumn = this.cur_menu.DepartmentColumn;

        curlist = this.curmenu_departmentlist;
        curorder = this.find_cur_department(this.movingprod.DepartmentIDn);
        len = this.curmenu_departmentlist.length;
      } else if (this.movingtype == "category") {
        btnw = this.menuCateBtnWidth;
        btnh = this.menuCateBtnHeight;
        btncolumn = this.cur_menu.CategoryColumn;

        curlist = this.curmenu_categorylist;
        curorder = this.find_cur_category(this.curmenu_categorylist, this.movingprod.CategoryIDn);
        len = this.curmenu_categorylist.length;
      } else if (this.movingtype == "product") {
        btnw = this.menuProdBtnWidth;
        btnh = this.menuProdBtnHeight;
        btncolumn = this.cur_menu.ProductColumn;

        curlist = this.curmenu_productlist;
        curorder = this.find_cur_product(this.curmenu_productlist, this.movingprod.ProductIDn);
        len = this.curmenu_productlist.length;
      } else {
        ; // console.log("drop event with unknown type: ", this.movingtype);
        return;
      }
      var offx = parseInt((ev.screenX - this.movingleft) / btnw);
      var offy = parseInt((ev.screenY - this.movingtop) / btnh);
      var curcol = curorder % btncolumn;
      var currow = parseInt(curorder / btncolumn);
      var newcol = curcol + offx;
      var newrow = currow + offy;
      if (newcol < 0) {
        newcol = 0;
      } else if (newcol >= btncolumn) {
        newcol = btncolumn - 1;
      }
      if (newrow < 0) {
        newrow = 0;
      }

      let neworder = newrow * btncolumn + newcol;
      if (neworder >= len) {
        neworder = len;
      }


      if (curorder != neworder) {
        if (this.movingtype == "department") {
          this.curmenu_departmentlist = this.array_move(this.curmenu_departmentlist, curorder, neworder);
          if (this.curmenu_departmentlist) {
            for (var i = 0; i < this.curmenu_departmentlist.length; i++) {
              this.curmenu_departmentlist[i].SortOrder = i + 1;
            }
          }
        } else if (this.movingtype == "category") {
          this.curmenu_categorylist = this.array_move(this.curmenu_categorylist, curorder, neworder);
          if (this.curmenu_categorylist) {
            for (var i = 0; i < this.curmenu_categorylist.length; i++) {
              this.curmenu_categorylist[i].SortOrder = i + 1;
            }
          }
        } else if (this.movingtype == "product") {
          this.curmenu_productlist = this.array_move(this.curmenu_productlist, curorder, neworder);
          if (this.curmenu_productlist) {
            for (var i = 0; i < this.curmenu_productlist.length; i++) {
              this.curmenu_productlist[i].SortOrder = i + 1;
            }
          }
        }
        this.change_cur_menu();
      } else {
        this.showloading = false;
      }
    },
    // Do change buttons color
    set_all_botton_color(ev, whattodo) {
      if (ev && (ev.target != undefined)) {
        ev.preventDefault();
      }
      if (whattodo == 'all') {
        if (this.cur_operating != 2) {
          return;
        }
        for (var i = 0; i < this.curmenu_departmentlist.length; i++) {
          var dpt = this.curmenu_departmentlist[i];
          dpt.BtnColor = this.btnToColor;
          for (var j = 0; j < dpt.Categorys.length; j++) {
            var cat = dpt.Categorys[j];
            cat.BtnColor = this.btnToColor;
            for (var k = 0; k < cat.Products.length; k++) {
              var prd = cat.Products[k];
              prd.BtnColor = this.btnToColor;
            }
          }
        }
        this.showloading = true;
        this.resize_buttons_department();
        this.resize_buttons_category();
        this.resize_buttons_product();
      } else if (whattodo == 'department') {
        if (this.curmenu_departmentlist) {
          let newdlist = this.curmenu_departmentlist;
          for (var i = 0; i < newdlist.length; i++) {
            newdlist[i].BtnColor = this.btnDToColor;
          }
          this.resize_buttons_department();
        }
      } else if (whattodo == 'category') {
        if (this.curmenu_categorylist) {
          let newclist = this.curmenu_categorylist;
          for (var i=0; i<newclist.length; i++) {
            newclist[i].BtnColor = this.btnCToColor;
          }
          this.resize_buttons_category();
        }
      } else if (whattodo == 'product') {
        if (this.curmenu_productlist) {
          let newplist = this.curmenu_productlist;
          for (var i=0; i<newplist.length; i++) {
            newplist[i].BtnColor = this.btnPToColor;
          }
          this.resize_buttons_product();
        }
      }
      this.change_cur_menu();
    },
    // Do change department button color
    edit_department(ev, prod) {
      ev.preventDefault();
      if (this.cur_operating != 2) {
        this.showloading = true;
        this.select_product(prod.DepartmentIDn, 'department')
        this.showloading = false;
        return;
      }
      prod.BtnColor = this.btnToColor;
      prod.idx = this.cur_idx++;
      // this.set_menu_department_idx();
      this.change_cur_menu();
      // return this.update_color(prod.IDn, 'department');
    },
    // Do change category button color
    edit_category(ev, prod) {
      ev.preventDefault();
      if (this.cur_operating != 2) {
        this.showloading = true;
        this.select_product(prod.CategoryIDn, 'category')
        this.showloading = false;
        return;
      }
      prod.BtnColor = this.btnToColor;
      prod.idx = this.cur_idx++;
      // this.set_menu_category_idx();
      this.change_cur_menu();
      // return this.update_color(prod.IDn, 'category');
    },
    // Do change product button color
    edit_product(ev, prod) {
      ev.preventDefault();
      if (this.cur_operating == 2) {
        prod.BtnColor = this.btnToColor;
        prod.idx = this.cur_idx++;
        // this.set_menu_product_idx();
        this.change_cur_menu();
        // return this.update_color(prod.IDn, 'product');
      } else if (this.cur_operating == 0) {
        this.showloading = true;
        this.select_product(prod.ProductIDn, 'product')
        this.showloading = false;
      }
    },
    // For convert data to good data type
    format_meun(menu) {
      menu.PanelWidth = parseInt(menu.PanelWidth);
      menu.PanelHeigh = parseInt(menu.PanelHeigh);
      menu.DepartmentHeight = parseInt(menu.DepartmentHeight);
      menu.CategoryHeight = parseInt(menu.CategoryHeight);
      menu.ProductHeight = parseInt(menu.ProductHeight);
      menu.DepartmentRow = parseInt(menu.DepartmentRow);
      menu.DepartmentColumn = parseInt(menu.DepartmentColumn);
      menu.DepartmentFontSize = parseInt(menu.DepartmentFontSize);
      menu.DepartmentFontWeight = parseInt(menu.DepartmentFontWeight);
      menu.CategoryRow = parseInt(menu.CategoryRow);
      menu.CategoryColumn = parseInt(menu.CategoryColumn);
      menu.CategoryFontSize = parseInt(menu.CategoryFontSize);
      menu.CategoryFontWeight = parseInt(menu.CategoryFontWeight);
      menu.ProductRow = parseInt(menu.ProductRow);
      menu.ProductColumn = parseInt(menu.ProductColumn);
      menu.ProductFontSize = parseInt(menu.ProductFontSize);
      menu.ProductFontWeight = parseInt(menu.ProductFontWeight);
      menu.IsOnline = parseInt(menu.IsOnline);
      menu.IsEMenu = parseInt(menu.IsEMenu);
      menu.mustHave = parseInt(menu.mustHave);
      menu.menuTimeControl = parseInt(menu.menuTimeControl);
      menu.menuOrder = parseInt(menu.menuOrder);
    },
    // re-get current menu data
    async getcur_menu() {
      this.showloading = true;
      // this will be called only after form is valid. You can do api call here to login
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("MenuIDn", this.cur_MenuIDn);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Menu/get_curent_menu",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_MenuIDn = rt.data.MenuIDn;
              var lt = typeof rt.data.menu.LocationID;
              if (lt != 'object') {
                rt.data.menu.LocationID = [];
              }
              that.cur_menu = rt.data.menu;
              that.isDraft = rt.data.isDraft;
              that.onlineList = rt.data.onlineList;
              that.format_meun(that.cur_menu);
              var tmpmenu = rt.data.menu_departments;   // Real Menu data list
              if (tmpmenu.length > 0) {
                let dcolor = false;
                let ccolor = false;
                let pcolor = false;
                for (var i = 0; i < tmpmenu.length; i++) {
                  tmpmenu[i].idx = that.cur_idx++;
                  if (!dcolor) {
                    that.btnDToColor = tmpmenu[i].BtnColor;
                    dcolor = true;
                  }
                  for (var j = 0; j < tmpmenu[i].Categorys.length; j++) {
                    tmpmenu[i].Categorys[j].idx = that.cur_idx++;
                    if (!ccolor) {
                      that.btnCToColor = tmpmenu[i].Categorys[j].BtnColor;
                      ccolor = true;
                    }
                    for (var k = 0; k < tmpmenu[i].Categorys[j].Products.length; k++) {
                      tmpmenu[i].Categorys[j].Products[k].idx = that.cur_idx++;
                      if (!pcolor) {
                        that.btnPToColor = tmpmenu[i].Categorys[j].Products[k].BtnColor;
                        pcolor = true;
                      }
                    }
                  }
                }
              }
              that.curmenu_departmentlist = tmpmenu;
              that.setcur_menu();
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          console.log(error);
          that.$router.push("/login");
        });
    },
    // Find department from left list
    find_department(dptIDn) {
      for (var i = 0; i < this.fulllist.length; i++) {
        if (this.fulllist[i].IDn == dptIDn) {
          return i;
        }
      }
      return -1;
    },
    // Find category from left list
    find_category(cats, catIDn) {
      if (!cats) {
        return -1;
      }
      for (var i = 0; i < cats.length; i++) {
        if (cats[i].IDn == catIDn) {
          return i;
        }
      }
      return -1;
    },
    // Find category from left list
    find_product(prds, prdIDn) {
      if (!prds) {
        return -1;
      }
      for (var i = 0; i < prds.length; i++) {
        if (prds[i].IDn == prdIDn) {
          return i;
        }
      }
      return -1;
    },
    // Find department index of right menu
    find_cur_department(dptIDn) {
      for (var i = 0; i < this.curmenu_departmentlist.length; i++) {
        if (this.curmenu_departmentlist[i].DepartmentIDn == dptIDn) {
          return i;
        }
      }
      return -1;
    },
    // Find category index of right menu
    find_cur_category(cats, catIDn) {
      if (!cats) {
        return -1;
      }
      for (var i = 0; i < cats.length; i++) {
        if (cats[i].CategoryIDn == catIDn) {
          return i;
        }
      }
      return -1;
    },
    // Find product index of right menu
    find_cur_product(prds, prdIDn) {
      if (!prds) {
        return -1;
      }
      for (var i = 0; i < prds.length; i++) {
        if (prds[i].ProductIDn == prdIDn) {
          return i;
        }
      }
      return -1;
    },
    // Find product that come from other category
    fullfind_product(prdIDn) {
      for (var i = 0; i < this.fulllist.length; i++) {
        for (var j = 0; j < this.fulllist[i].Categorys.length; j++) {
          for (var k = 0; k < this.fulllist[i].Categorys[j].Products.length; k++) {
            if (this.fulllist[i].Categorys[j].Products[k].IDn == prdIDn) {
              return this.fulllist[i].Categorys[j].Products[k];
            }
          }
        }
      }
      return false;
    },
    // Init Menu Data
    reset_cur_menu_data() {
      this.cur_DepartmentIDn = 0;
      this.cur_CategoryIDn = 0;
      this.cur_ProductIDn = 0;
      this.leftcategory = [];
      this.leftproduct = [];
      this.curmenu_categorylist = [];
      this.curmenu_productlist = [];
    },
    // Setup current default display status
    setcur_menu() {
      if (this.cur_MenuIDn > 0) {
        this.active_tab = this.cur_MenuIDn + "tab";
      } else {
        // Add New Menu
        this.active_tab = "add";
        this.cur_MenuIDn = 0;
        this.new_menu_get_all = 0;
        this.cur_menu = JSON.parse(JSON.stringify(this.new_menu));
        return;
      }

      for (var di = 0; di < this.fulllist.length; di++) {
        this.fulllist[di].show = 1;
        for (var ci = 0; ci < this.fulllist[di].Categorys.length; ci++) {
          this.fulllist[di].Categorys[ci].show = 1;
          for (var pi = 0; pi < this.fulllist[di].Categorys[ci].Products.length; pi++) {
            this.fulllist[di].Categorys[ci].Products[pi].show = 1;
          }
        }
      }

      this.reset_cur_menu_data();
      if (this.curmenu_departmentlist.length > 0) {
        this.cur_DepartmentIDn = this.curmenu_departmentlist[0].DepartmentIDn;
        if (this.curmenu_departmentlist[0].Categorys.length > 0) {
          this.cur_CategoryIDn = this.curmenu_departmentlist[0].Categorys[0].CategoryIDn;
          if (this.curmenu_departmentlist[0].Categorys[0].Products.length > 0) {
            this.cur_ProductIDn = this.curmenu_departmentlist[0].Categorys[0].Products[0].ProductIDn;
          }
        }
      }
      if (this.cur_DepartmentIDn > 0) {
        let didx = this.find_department(this.cur_DepartmentIDn);
        if (didx >= 0) {
          this.leftcategory = this.fulllist[didx]["Categorys"];
          if (this.cur_CategoryIDn > 0) {
            let cidx = this.find_category(this.leftcategory, this.cur_CategoryIDn);
            if (cidx >= 0) {
              this.leftproduct = this.leftcategory[cidx]["Products"];
            }
          }
        }
      }

      // get current menu product name from full list and remove show flag from full list
      for (var dmi = 0; dmi < this.curmenu_departmentlist.length; dmi++) {
        var mdpt = this.curmenu_departmentlist[dmi];
        var di = this.find_department(mdpt.DepartmentIDn);
        if (di < 0) {
          this.dismessage = "Menu can't find correstponding department, please contact support. MenuID:" + this.cur_MenuIDn + "; DptID:" + mdpt.DepartmentIDn;
          this.countdown = 20;
          return;
        }
        this.fulllist[di].show = 0;
        mdpt.Name1 = this.fulllist[di].Name1;
        mdpt.Name2 = this.fulllist[di].Name2;
        if (this.cur_DepartmentIDn == mdpt.DepartmentIDn) {
          this.curmenu_categorylist = this.curmenu_departmentlist[dmi].Categorys;
        }
        for (var cmi = 0; cmi < this.curmenu_departmentlist[dmi].Categorys.length; cmi++) {
          var mcat = this.curmenu_departmentlist[dmi].Categorys[cmi];
          var ci = this.find_category(this.fulllist[di].Categorys, mcat.CategoryIDn);
          if (ci < 0) {
            this.dismessage = "Menu can't find correstponding category, please contact support. MenuID:" + this.cur_MenuIDn + "; DptID:" + mdpt.DepartmentIDn + "; CatID:" + mcat.CategoryIDn;
            this.countdown = 20;
            return;
          }
          this.fulllist[di].Categorys[ci].show = 0;
          mcat.Name1 = this.fulllist[di].Categorys[ci].Name1;
          mcat.Name2 = this.fulllist[di].Categorys[ci].Name2;
          if (this.cur_CategoryIDn == mcat.CategoryIDn) {
            this.curmenu_productlist = this.curmenu_departmentlist[dmi].Categorys[cmi].Products;
          }
          for (var pmi = this.curmenu_departmentlist[dmi].Categorys[cmi].Products.length - 1; pmi >= 0; pmi--) {
            var mprd = this.curmenu_departmentlist[dmi].Categorys[cmi].Products[pmi];
            var pi = this.find_product(this.fulllist[di].Categorys[ci].Products, mprd.ProductIDn);
            if (pi < 0) {
              // Maybe from other category
              var tprd = this.fullfind_product(mprd.ProductIDn);
              if (tprd) {
                mprd.Name1 = tprd.Name1;
                mprd.Name2 = tprd.Name2;
              }
              continue;
            }
            if (this.fulllist[di].Categorys[ci].Products[pi].Status == "Deactive") {
              this.curmenu_departmentlist[dmi].Categorys[cmi].Products.splice(pmi,1);
              continue;
            }

            this.fulllist[di].Categorys[ci].Products[pi].show = 0;
            mprd.Name1 = this.fulllist[di].Categorys[ci].Products[pi].Name1;
            mprd.Name2 = this.fulllist[di].Categorys[ci].Products[pi].Name2;
          }
        }
      }
      this.resize_buttons();
    },
    check_changed_tabs(newname, oldname) {
      if (this.isDraft && (oldname != undefined) && (oldname != 0) && (oldname != 'add') ) {
        this.dismessage = "Please finish current editing Menu or cancel all changes";
        this.countdown = 3;
        return false;
      }
      return true;
    },
    changed_tabs(tab, event) {
      this.cur_operating = 0;
      if (this.active_tab != "add") {
        this.cur_MenuIDn = parseInt(this.active_tab);
        setStore("defaultMenuIDn", this.cur_MenuIDn);
        this.getcur_menu();
      } else {
        this.cur_MenuIDn = 0;
        this.cur_menu = JSON.parse(JSON.stringify(this.new_menu));
      }
    },
    add_all(what) {
      // department, category, product
      var products = "";
      if (what == "department") {
        for (var i = 0; i < this.fulllist.length; i++) {
          this.add_product(this.fulllist[i].IDn, what, false);
        }
        this.cur_DepartmentIDn = this.curmenu_departmentlist[0].DepartmentIDn;
        this.curmenu_categorylist = this.curmenu_departmentlist[0].Categorys;
        if (this.curmenu_categorylist.length > 0) {
          this.cur_CategoryIDn = this.curmenu_categorylist[0].CategoryIDn;
          this.curmenu_productlist = this.curmenu_categorylist[0].Products;
          if (this.curmenu_productlist.length > 0) {
            this.cur_ProductIDn = this.curmenu_productlist[0].ProductIDn;
          }
        }
        this.select_product(this.cur_DepartmentIDn, what);
      } else if (what == "category") {
        this.cur_CategoryIDn = 0;
        this.cur_ProductIDn = 0;

        let didx = this.find_department(this.cur_DepartmentIDn);
        if (didx < 0) {
          alert("Category belongs to Department data error");
          return;
        }
        if (this.fulllist[didx].show) {
          alert("Add Department first");
          return;
        }

        for (var i = 0; i < this.leftcategory.length; i++) {
          this.add_product(this.leftcategory[i].IDn, what, false);
        }
        if (this.curmenu_categorylist.length > 0) {
          this.cur_CategoryIDn = this.curmenu_categorylist[0].CategoryIDn;
          this.curmenu_productlist = this.curmenu_categorylist[0].Products;
          if (this.curmenu_productlist.length > 0) {
            this.cur_ProductIDn = this.curmenu_productlist[0].ProductIDn;
          }
          this.select_product(this.cur_CategoryIDn, what);
        }
      } else if (what == "product") {
        this.cur_ProductIDn = 0;

        let cidx = this.find_category(this.leftcategory, this.cur_CategoryIDn);
        if (cidx < 0) {
          alert("Product belongs to Category data error");
          return;
        }
        if (this.leftcategory[cidx].show) {
          alert("Add Category first");
          return;
        }

        for (var i = 0; i < this.leftproduct.length; i++) {
          this.add_product(this.leftproduct[i].IDn, what, false);
        }
        if (this.curmenu_productlist.length > 0) {
          this.cur_ProductIDn = this.curmenu_productlist[0].ProductIDn;
          this.select_product(this.cur_ProductIDn, what);
        }
      }
      this.change_cur_menu();
    },
    remove_all(what) {
      // department, category, product
      // Only product remove_all is allowed
      var products = "";
      if (what == "department") {
        alert("This option isn't allowed");
        return;
      } else if (what == "category") {
        alert("This option isn't allowed");
        return;
      } else if (what == "product") {
        if (this.curmenu_productlist.length <= 0) {
          return;
        }
        var midx = this.find_cur_category(this.curmenu_categorylist, this.curmenu_productlist[0].CategoryIDn);
        if (midx < 0) {
          alert("The product data has problem");
          return;
        }
        for (var i = 0; i < this.curmenu_productlist.length; i++) {
          var idx = this.find_product(this.leftproduct, this.curmenu_productlist[i].ProductIDn);
          if (idx >= 0) {
            this.leftproduct[i].show = 1;
          }
        }
        this.curmenu_categorylist[midx].Products = [];
        this.curmenu_productlist = [];
      }
      this.change_cur_menu();
    },
    add_menu() {
      if (this.cur_menu.Name1 == "") {
        alert("Please Input Name1");
        return;
      }
      if (this.cur_menu.Name2 == "") {
        alert("Please Input Name2");
        return;
      }
      if (this.cur_menu.LocationID == "") {
        alert("Please select Store");
        return;
      }

      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("Menu", JSON.stringify(this.cur_menu));
      bodyFormData.append("GetAll", this.new_menu_get_all);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/menu/add_menu",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_MenuIDn = rt.data.MenuIDn;
              that.isDraft = 0;
              that.get_menu_list();
              // that.$router.go();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    copy_menu() {
      if (this.copy_Menu_IDn == 0) {
        alert("Please select Menu to Copy");
        return;
      }
      if (this.copy_Name1 == "") {
        alert("Please Input Name1");
        return;
      }
      if (this.copy_Name2 == "") {
        alert("Please Input Name2");
        return;
      }

      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("Name1", this.copy_Name1);
      bodyFormData.append("Name2", this.copy_Name2);
      bodyFormData.append("MenuIDn", this.copy_Menu_IDn);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/menu/copy_menu",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.cur_MenuIDn = rt.data.MenuIDn;
              that.isDraft = 0;
              that.get_menu_list();
              // that.$router.go();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    copy_price() {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("PriceF", this.copy_PriceF);
      bodyFormData.append("PriceT", this.copy_PriceT);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/store/copy_price_group",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.dismessage = rt.data.message;
              that.countdown = 2;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    change_online() {
      this.change_cur_menu();
    },
    // Set new department idx for vue key value for redrew
    set_menu_department_idx() {
      if (!this.curmenu_departmentlist) {
        return;
      }
      var len = this.curmenu_departmentlist.length;
      for (var i = 0; i < len; i++) {
        this.curmenu_departmentlist[i].idx = this.cur_idx++;
      }
    },
    // Set new category idx for vue key value for redrew
    set_menu_category_idx() {
      if (!this.curmenu_categorylist) {
        return;
      }
      var len = this.curmenu_categorylist.length;
      for (var i = 0; i < len; i++) {
        this.curmenu_categorylist[i].idx = this.cur_idx++;
      }
    },
    // Set new product idx for vue key value for redrew
    set_menu_product_idx() {
      if (!this.curmenu_productlist) {
        return;
      }
      var len = this.curmenu_productlist.length;
      for (var i = 0; i < len; i++) {
        this.curmenu_productlist[i].idx = this.cur_idx++;
      }
    },
    // Change to save current menu changes, reload???, redraw???
    changed_store() {
      this.change_cur_menu();
    },
    // Change to save current menu changes, reload???, redraw???
    change_cur_menu(who='') {
      if (who == 'department') {
        this.resize_buttons_department();
      }
      if (who == 'category') {
        this.resize_buttons_category();
      }
      if (who == 'product') {
        this.resize_buttons_product();
      }
      if (this.sync_to_server) {
        clearTimeout(this.sync_to_server);
      }
      this.sync_to_server = setTimeout(this.do_change_cur_menu, 200);
    },
    // Change to save current menu changes, reload???, redraw???
    do_change_cur_menu() {
      this.showloading = true;

      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("MenuIDn", this.cur_MenuIDn);
      var Content = {menu: this.cur_menu, departments: this.curmenu_departmentlist};
      bodyFormData.append("Content", JSON.stringify(Content));

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/menu/save_menu_draft",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.isDraft = true;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    // Get All menu records (no menu structure) and current menu structure
    async get_menu_list(isInit=false) {
      if (isInit) {
        let defaultMenuIDn = getStore("defaultMenuIDn");
        if (defaultMenuIDn) {
          defaultMenuIDn = parseInt(defaultMenuIDn);
          if (defaultMenuIDn) {
            this.cur_MenuIDn = defaultMenuIDn;
          }
        }
      }
      this.showloading = true;
      // this will be called only after form is valid. You can do api call here to login
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("MenuIDn", this.cur_MenuIDn);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Menu",
        data: bodyFormData,
      })
        .then(function (response) {
          that.showloading = false;
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.storelist = rt.data.stores;
              if (that.storelist.length <= 0) {
                // If there is no store yet. Redirct to get store data first
                that.$router.push("/store");
                return;
              }
              that.statuses = rt.data.statuses;
              that.isDraft = rt.data.isDraft;
              that.cur_MenuIDn = rt.data.MenuIDn;
              that.menulist = rt.data.menus;
              that.fulllist = rt.data.departments;
              that.getcur_menu();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    async upload_ldw() {
      var msg = "";
      this.upload_file_list = [];
      this.upload_file_ids = [];
      this.upload_product_dialog = true;
      this.upload_show_close = false;

      for (var dmi = 0; dmi < this.curmenu_departmentlist.length; dmi++) {
        for (var cmi = 0; cmi < this.curmenu_departmentlist[dmi].Categorys.length; cmi++) {
          for (var pmi = this.curmenu_departmentlist[dmi].Categorys[cmi].Products.length - 1; pmi >= 0; pmi--) {
            var mprd = this.curmenu_departmentlist[dmi].Categorys[cmi].Products[pmi];
            this.upload_file_ids.push(mprd.ProductIDn);
          }
        }
      }
      this.upload_file_cnt = 0;
      this.upload_ldw_one();
    },
    scrolldown(msg) {
      this.upload_file_list.push(msg);
      var container = this.$el.querySelector("#upload_product_ref");
      container.scrollTop = container.scrollHeight;
    },
    async delete_menu() {
      if (confirm(this.$t("If deleted, data will be impossible to recover."))) {
        var bodyFormData = new FormData();
        bodyFormData.append("token", this.token);
        bodyFormData.append("user_id", this.user_id);
        bodyFormData.append("MenuIDn", this.cur_MenuIDn);

        var that = this;
        axios({
          method: "post",
          url: "/Api/Web/Menu/delete",
          data: bodyFormData,
        }).then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.get_menu_list(true);
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
          }
        }).catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
      }
    },
    async upload_ldw_one() {
      var ProductIDn = this.upload_file_ids[this.upload_file_cnt];
      if ((ProductIDn == undefined) || (this.upload_file_cnt >= this.upload_file_ids.length)) {
        this.upload_show_close = true;
        // this.upload_product_dialog = false;
      }
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("ProductIDn", ProductIDn);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Pos_setting/uploadLdwImage",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.scrolldown(rt.data.message);
              that.upload_file_cnt++;
              that.upload_ldw_one();
            } else if (rt.status == 4) {
              that.upload_show_close = true;
              that.scrolldown("No Permission");
            } else if (rt.message != undefined) {
              that.upload_show_close = true;
              that.scrolldown(rt.message);
            }
          } else {
            that.upload_show_close = true;
            that.scrolldown("Upload Failured!!!");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.upload_show_close = true;
          that.scrolldown("Upload Failured !!");
        });
    },
    async get_ldw() {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Pos_setting/getLdwCode",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              var ldw = rt.data.ldw;
              if (ldw && (ldw.length > 0)) {
                that.hasLdwUpload = true;
              }
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    beforeUnloadHandler(event) {
      if(this.isDraft) {
        event.preventDefault();
        event.returnValue = ''; // Chrome requires a non-empty string to show a prompt
      }
    },
    async init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      let name = getStore("username");
      var today = new Date();
      let todaystr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
      today.setFullYear(today.getFullYear() + 10);
      let tenyearstr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');

      this.new_menu.StartDate = todaystr;
      this.new_menu.EndDate = tenyearstr;

      if (name && name != undefined && ((name == "PKAdmin") || (name == "posking"))) {
        this.pkadmin = true;
      }

      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      this.get_ldw();
      return this.get_menu_list(true);
    },
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    if (window.innerWidth > 1024) {
      this.panel_left = { width: "280px" };
    }
    this.init_data();
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  },
  beforeRouteLeave(to, from, next) {
    // Check if the user is navigating within the same website
    if (to.path.startsWith('/') && this.isDraft) {
      // Prompt the user before leaving the page
      if (confirm('Are you sure you want to leave this page?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>
<style scoped>
.content {
  padding-top: 80px;
}
.template-class {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.template-sub {
  width: 10rem;
  height: 6.5rem;
  margin: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left_menu_font {
  font-size: .8rem;
}
.left_menu_font .border-dark {
  border-color: #bbbbbb !important;
  font-weight: bold;
  position: relative;
}
.department_div {
  border: 1px solid #bbbbbb;
  width: 100%;
  height: 80px;
  overflow: auto;
  position: relative;
  margin-bottom: .1rem;
}
.department_div2 {
  border: 1px solid #bbbbbb;
  width: 100%;
  height: 60px;
  overflow: auto;
  position: relative;
  margin-bottom: .1rem;
}
.category_div {
  border: 1px solid #bbbbbb;
  width: 100%;
  overflow: auto;
  position: relative;
  height: 120px;
  margin-bottom: .1rem;
}
.category_div2 {
  border: 1px solid #bbbbbb;
  width: 100%;
  overflow: auto;
  position: relative;
  height: 144px;
  margin-bottom: .1rem;
}
.product_div {
  border: 1px solid #bbbbbb;
  width: 100%;
  overflow: auto;
  position: relative;
  height: 460px;
}
.product_div2 {
  border: 1px solid #bbbbbb;
  width: 100%;
  overflow: auto;
  position: relative;
  height: 306px;
}
.department_button {
  padding-top: 20px;
  width: 100%;
  height: 100px;
  overflow: auto;
  position: relative;
}
.department_button2 {
  padding-top: 8px;
  width: 100%;
  height: 66px;
  overflow: auto;
  position: relative;
}
.category_button {
  padding-top: 70px;
  width: 100%;
  height: 220px;
  overflow: auto;
  position: relative;
}
.category_button2 {
  padding-top: 44px;
  width: 100%;
  height: 147px;
  overflow: auto;
  position: relative;
}
.product_button {
  padding-top: 140px;
  width: 100%;
  height: 600px;
  overflow: auto;
  position: relative;
}
.product_button2 {
  padding-top: 96px;
  width: 100%;
  height: 400px;
  overflow: auto;
  position: relative;
}
.department_list {
  background: #e0e0e0;
}
.menulabel {
  font-size: 14px;
}
.category_list {
  background: #e0e0e0;
}
.product_list {
  background: #e0e0e0;
}
.meun_pad_list {
  padding-left: 0px;
  padding-right: 0px;
}
.search-button {
  margin-top: 2rem;
}
.card .table td {
  padding: 0.5rem;
}
.product_select {
  background: #e0e0e0;
  border: 2px solid #bbbbbb;
  border-radius: 5px;
  height: 24rem;
  margin-bottom: 1rem;
  overflow: auto;
}
.page_hr {
  margin: 0px;
}
.product {
  color: #202020;
}
.panel-middle {
  width: 20px;
}
.panel-middle2 {
  width: 8px;
}
.pad_panel {
  width: 674px;
  height: 663px;
  background: chartreuse;
  line-height: 14px;
}
.pad_panel2 {
  width: 445px;
  height: 440px;
  background: chartreuse;
  line-height: 7px;
}
.panel_list {
  height: 10px;
  width: 100%;
  background: #e0e0e0;
  border-radius: 5px;
  border: 1px none;
  overflow: auto;
  position: relative;
}
.left_panel_sm_font {
  font-size: 0.5rem;
}
.hr-line {
  width: 100%;
  height: 3px;
  cursor: row-resize;
  background: #ffffff;
  color: #ffffff;
  border-top: 1px solid #606060;
  border-bottom: 1px solid #606060;
  border-right: none;
  border-left: none;
  position: relative;
}
.colorsquire {
  width: 24px;
  height: 24px;
  margin-left: 6px;
  display: inline-block;
  border-radius: 5px;
  box-shadow: 2px 2px #606060;
}
.menu-button-color {
  top: 8px;
}
.el-input-number--mini {
  width: 95px;
}
.menupage .el-form-item,.el-form-item--small {
  margin-bottom: 0px;
}
.menupage .widthdate {
  width: 60%;
}
.menupage .el-select {
  width: 95px;
}
.menupage .leftmenuitem {
  cursor: pointer;
}
.upload_ldw {
  margin-left: 2rem;
}
.upload_product_div {
  height: 10rem;
  overflow: scroll;
}
</style>
